import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeviceCondition_Interface, Empty_DeviceCondition_Interface } from 'src/app/Interface/DeviceCondition_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceConditionService } from 'src/app/Service/Device/DeviceCondition.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-DeviceConditionList',
  templateUrl: './DeviceConditionList.component.html',
  styleUrls: ['./DeviceConditionList.component.scss']
})
export class DeviceConditionListComponent implements OnInit {
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private DeviceCondition_Service:DeviceConditionService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_DeviceCondition:Array<DeviceCondition_Interface>=[]
  Data_Seleted_Delete:DeviceCondition_Interface=Empty_DeviceCondition_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(2183).subscribe(
      data=>{
        this.ReadData_DeviceCondition()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_DeviceCondition(){
    this.Procssing=true
    this.DeviceCondition_Service.GetRecord().subscribe(
      data=>{
        this.DataList_DeviceCondition=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }


}
